export default (transportMode) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: "contractSortInfo",
    width: 100,
    align: "center",
    title: "合同序号",
  },
  {
    field: 'carrierName',
    title: '承运商名称',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'center',
    width: 120,
    title: '组织机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'contractCarrierName',
    align: 'center',
    width: 120,
    title: '合同名称',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'transportModeName',
    align: 'left',
    width: 120,
    title: '运输模式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'chargeUnitName',
    align: 'left',
    width: 120,
    title: '计费单位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'settlementMethodName',
    align: 'center',
    width: 150,
    title: '结算方式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'startDate',
    align: 'center',
    width: 120,
    title: '开始日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'endDate',
    align: 'center',
    width: 120,
    title: '结束日期',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'validDays',
    align: 'center',
    width: 120,
    title: '有效期天数',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'weightTypeName',
    align: 'center',
    width: 150,
    title: '重泡属性',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'useTransWeightName',
    align: 'center',
    width: 120,
    title: '是否启用重泡比',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'useTransWeightRatio',
    align: 'center',
    width: 80,
    title: '重泡比',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'numberDecimal',
    align: 'center',
    width: 100,
    title: '保留小数位数',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'roundingMethodName',
    align: 'left',
    minWidth: 120,
    title: '进位方式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '合同线路信息',
    align: 'center',
    children: [
      {
        field: "contractSort",
        width: 100,
        align: "center",
        title: "关联合同序号",
      },
      {
        headerAlign: 'center',
        field: 'originProvinceName',
        align: 'center',
        width: 100,
        title: '始发地（省）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'originCityName',
        align: 'center',
        width: 100,
        title: '始发地（市）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'originDistrictName',
        align: 'center',
        width: 100,
        title: '始发地（区）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'destinationProvinceName',
        align: 'center',
        width: 100,
        title: '目的地（省）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'destinationCityName',
        align: 'center',
        width: 100,
        title: '目的地（市）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'destinationDistrictName',
        align: 'center',
        width: 100,
        title: '目的地（区）',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'lineTime',
        align: 'center',
        width: 80,
        title: '时效',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'orderTypeName',
        align: 'center',
        width: 120,
        title: '订单类型',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'goodsTypeName',
        align: 'center',
        width: 120,
        title: '货品类型',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'bizTypeName',
        align: 'center',
        width: 120,
        title: '业务类型',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'linePriceTypeName',
        align: 'center',
        width: 120,
        title: '业务类型',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'isBackName',
        align: 'center',
        width: 120,
        title: '是否返程',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
      },
      {
        headerAlign: 'center',
        field: 'lineMinPrice',
        align: 'center',
        width: 80,
        title: '最低收费',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: !transportMode,
      },
      {
        headerAlign: 'center',
        field: 'vehicleModelName',
        align: 'center',
        width: 80,
        title: '车型',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: transportMode,
      },
      {
        headerAlign: 'center',
        field: 'vehicleLengthName',
        align: 'center',
        width: 80,
        title: '车长',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: transportMode,
      },
      {
        headerAlign: 'center',
        field: 'vehicleLoad',
        align: 'center',
        width: 80,
        title: '载重',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: transportMode,
      },
      {
        headerAlign: 'center',
        field: 'vehicleVolume',
        align: 'center',
        width: 80,
        title: '载方',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: transportMode,
      },
      {
        headerAlign: 'center',
        field: 'price',
        align: 'center',
        width: 80,
        title: '总价',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: transportMode,
      },
      {
        headerAlign: 'center',
        field: 'minMatch',
        align: 'center',
        width: 80,
        title: '区间下限',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: !transportMode,
      },
      {
        headerAlign: 'center',
        field: 'maxMatch',
        align: 'center',
        width: 80,
        title: '区间上限',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: !transportMode,
      },
      {
        headerAlign: 'center',
        field: 'price2',
        align: 'center',
        width: 80,
        title: '单价/运价',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
        visible: !transportMode,
      },
    ]
  }
];
